// extracted by mini-css-extract-plugin
export default {"sample_btn":"bulkUpload_sample_btn__Enpy9","errors":"bulkUpload_errors__Pcmw1","error_list":"bulkUpload_error_list__WoXCU","field":"bulkUpload_field__deeNo"};